import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useCurrentUser } from '@/features/auth/hooks/use-current-user';
import { getUserCart } from '@/features/cart/api';
import { Cart } from '@/features/cart/types';

import { cartKeys } from '../keys';

import { useLocalCart } from './use-local-cart';

export const useUserCart = () => {
  const { data: userData } = useCurrentUser();
  const { data: userItems, ...restQuery } = useQuery({
    queryKey: cartKeys.cart,
    queryFn: getUserCart,
  });

  const localItems = useLocalCart((store) => store.items);

  const data = useMemo(() => {
    if (userData) {
      return userItems;
    }

    return {
      cartItems: localItems.map((item) => ({
        ...item,
        id: item.id,
        product: item.listing,
        variant: item.variant,
        cartId: 'local-cart',
        price: null,
        measurements: null,
      })),
      id: 'local-cart',
      userId: 'local-user',
    } as Cart;
  }, [localItems, userItems, userData]);

  return {
    data,
    ...restQuery,
  };
};
